import { render, staticRenderFns } from "./CreateUnitOwnerDialog.vue?vue&type=template&id=39dba91c&scoped=true"
import script from "./CreateUnitOwnerDialog.vue?vue&type=script&lang=js"
export * from "./CreateUnitOwnerDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateUnitOwnerDialog.vue?vue&type=style&index=0&id=39dba91c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dba91c",
  null
  
)

export default component.exports